<template>
  <div
    class="card card-player-collection"
    :class="'playlist-card-' + playlist.id"
  >
    <div class="playlists-card-image">
      <a
        :href="`?view-playlist=${playlist.id}`"
        @click.prevent="onPlaylistClick(playlist.id)"
      >
        <img
          class="rounded img-fluid"
          :src="getPlaylistImageUrl(playlist.image)"
          :alt="playlist.name"
        />
        <span v-if="isNew(playlist)" class="playlists-new-label">NEW</span>
      </a>
    </div>

    <div class="card-body">
      <a href="#" @click.prevent="onPlaylistClick(playlist.id)">
        <h4 class="card-title">
          {{ playlist.name }}
        </h4>
      </a>

      <p class="card-text">Tracks: {{ playlist.trackcount }}</p>

      <div>
        <a
          href="#"
          class="text-white share-playlist"
          v-on:click="share(playlist)"
        >
          <i class="material-icons">screen_share</i>
        </a>

        <a
          href="#"
          class="text-white share-playlist"
          v-on:click="download(playlist)"
        >
          <i class="material-icons">get_app</i>
        </a>

        <a
          href="#"
          class="text-white share-playlist save-playlist-as-project"
          @click.prevent.stop="savePlaylistAsProject(playlist)"
          title="Save Playlist as Project"
        >
          <i class="material-icons">save</i>
        </a>

        <span class="preview-playlist">
          <a
            href="#"
            class="preview-link float-right"
            v-on:click="playlistPreview(playlist.id)"
          >
            <i class="material-icons"></i>
            <span class="preview-text">Preview</span>
          </a>
          <br />
          <div class="preview-controls">
            <a
              href="#"
              class="preview-control next-link float-right"
              v-on:click="previewNextTrack(playlist.id)"
            >
              <i class="material-icons">skip_next</i>
            </a>
            <a
              href="#"
              class="preview-control pause-link float-right"
              v-on:click="previewPauseTrack(playlist.id)"
            >
              <i class="material-icons"></i>
            </a>
            <a
              href="#"
              class="preview-control stop-link float-right"
              v-on:click="previewStopTrack(playlist.id)"
            >
              <i class="material-icons">stop</i>
            </a>
            <a
              href="#"
              class="preview-control previous-link float-right"
              v-on:click="previewPreviousTrack(playlist.id)"
            >
              <i class="material-icons">skip_previous</i>
            </a>
          </div>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { playerService } from "../player-service";
import { audioService } from "../audio-service";
import ToastrType from "../toastr-types.interface";

export default Vue.component("playlists-tab-card", {
  name: "PlaylistsTabCard",

  props: {
    playlist: {
      type: Object,
      required: true,
    },
    asseturl: {
      type: String,
      required: true,
    },
  },
  methods: {
    getPlaylistImageUrl: function (image) {
      return image
        ? this.asseturl + "/" + image
        : this.asseturl + "/images/player-no-playlist-img.png";
    },

    onPlaylistClick: function (playlistId) {
      playerService.openPlaylist(playlistId);
    },

    share: function (playlist) {
      playerService.sharePlaylist(playlist);
    },

    download: function (playlist) {
      playerService.openDownloadTrackCollection(
        playlist.name,
        playlist.id,
        "playlists",
        playlist.trackcount,
      );
    },

    savePlaylistAsProject(playlist) {
      if (!playlist || typeof playlist.id === "undefined") {
        return false;
      }

      if (
        typeof playlist.trackcount !== "undefined" &&
        parseInt(playlist.trackcount, 10) === 0
      ) {
        playerService.toast(
          "This Playlist has no tracks to save.",
          ToastrType.Error,
        );
        return false;
      }

      return playerService.savePlaylistAsProject(playlist.id);
    },

    playlistPreview: function (playlistId) {
      let ctx = this;

      $(".card-player-collection").each(function () {
        if ($(this).hasClass(".playlist-card-" + playlistId)) {
        } else {
          $(this).find(".preview-playlist").removeClass("playing");
        }
      });

      $(".album-card-container").each(function () {
        $(this).find(".preview-album").removeClass("playing");
      });

      if (
        $(".playlist-card-" + playlistId + " .preview-playlist").hasClass(
          "playing",
        )
      ) {
        $(".playlist-card-" + playlistId + " .preview-playlist").removeClass(
          "playing",
        );
        $(".preview-control.pause-link").addClass("paused");
        audioService.pause();
      } else {
        $(".playlist-card-" + playlistId + " .preview-playlist").addClass(
          "playing",
        );
        $(".playlist-card-" + playlistId + " .preview-playlist").addClass(
          "hide-prev",
        );
        $(".preview-control.pause-link").removeClass("paused");

        let ajaxConfig = {
          method: "GET",
          url: "/api/playlists/getfirsttrack/" + playlistId,
          cache: false,
        };

        ctx.jqxhr = $.ajax(ajaxConfig)
          .done(function (response) {
            if (typeof response !== "undefined") {
              let first_track = response;
              audioService.stream(first_track);
            } else {
              if (window.adminProjectShare == true) {
                playerService.toast(
                  `[PLYR_221315] Error: Playlist Resource response was obtained but invalidated data schema was provided.`,
                  ToastrType.Error,
                );
              }
            }
          })
          .fail(function (responseData) {
            playerService.toast(
              `[PLYR_41648] Error: Could not load Track.`,
              ToastrType.Error,
            );

            if (
              typeof responseData.status !== "undefined" &&
              responseData.status == 419
            ) {
              playerService.$emit("open-browser-idle-too-long-modal");
            }
          });
      }
    },

    previewNextTrack: function (playlistId) {
      let ctx = this;

      if (
        $(".playlist-card-" + playlistId + " .preview-playlist").hasClass(
          "hide-next",
        )
      ) {
        return;
      }

      let currentTrack = $(".now-playing-track").attr("data-track-id");

      let ajaxConfig = {
        method: "GET",
        url: "/api/playlists/getnexttrack/" + playlistId + "/" + currentTrack,
        cache: false,
      };

      ctx.jqxhr = $.ajax(ajaxConfig)
        .done(function (response) {
          if (typeof response !== "undefined") {
            audioService.stream(response.data);

            if (response.message.current > 0) {
              $(
                ".playlist-card-" + playlistId + " .preview-playlist",
              ).removeClass("hide-prev");
            }

            if (response.message.current >= response.message.total - 1) {
              $(".playlist-card-" + playlistId + " .preview-playlist").addClass(
                "hide-next",
              );
            }
          } else {
            if (window.adminProjectShare == true) {
              playerService.toast(
                `Error: Could not load Next Track.`,
                ToastrType.Error,
              );
            }
          }
        })
        .fail(function (responseData) {
          playerService.toast(
            `[PLYR_41648] Error: Could not load Track.`,
            ToastrType.Error,
          );

          if (
            typeof responseData.status !== "undefined" &&
            responseData.status == 419
          ) {
            playerService.$emit("open-browser-idle-too-long-modal");
          }
        });
    },

    previewPreviousTrack: function (playlistId) {
      let ctx = this;

      if (
        $(".playlist-card-" + playlistId + " .preview-playlist").hasClass(
          "hide-prev",
        )
      ) {
        return;
      }

      let currentTrack = $(".now-playing-track").attr("data-track-id");

      let ajaxConfig = {
        method: "GET",
        url:
          "/api/playlists/getprevioustrack/" + playlistId + "/" + currentTrack,
        cache: false,
      };

      ctx.jqxhr = $.ajax(ajaxConfig)
        .done(function (response) {
          if (typeof response !== "undefined") {
            audioService.stream(response.data);

            $(
              ".playlist-card-" + playlistId + " .preview-playlist",
            ).removeClass("hide-next");

            if (response.message.current >= response.message.total - 1) {
              $(".playlist-card-" + playlistId + " .preview-playlist").addClass(
                "hide-prev",
              );
            }
          } else {
            if (window.adminProjectShare == true) {
              playerService.toast(
                `Error: Could not load Previous Track.`,
                ToastrType.Error,
              );
            }
          }
        })
        .fail(function (responseData) {
          playerService.toast(
            `[PLYR_41648] Error: Could not load Track.`,
            ToastrType.Error,
          );

          if (
            typeof responseData.status !== "undefined" &&
            responseData.status == 419
          ) {
            playerService.$emit("open-browser-idle-too-long-modal");
          }
        });
    },

    previewPauseTrack: function (playlistId) {
      if ($(".preview-control.pause-link").hasClass("paused")) {
        audioService.play();
        $(".preview-control.pause-link").removeClass("paused");
      } else {
        audioService.pause();
        $(".preview-control.pause-link").addClass("paused");
      }
    },

    previewStopTrack: function (playlistId) {
      $(".playlist-card-" + playlistId + " .preview-playlist").removeClass(
        "playing",
      );
      audioService.pause();
      $(".preview-control.pause-link").addClass("paused");
    },

    /**
     * Check if a new label should be applied to playlist
     */
    isNew(playlist) {
      return playlist.is_new;
    },
  },
});
</script>
